import * as tslib_1 from "tslib";
import React from 'react';
import { Select as NativeSelect } from 'sinoui-components/Select';
import { MenuListItem } from 'sinoui-components/Menu';
import { injectGlobal } from 'sinoui-components/styles';
import withField from './withField';
// tslint:disable-next-line:no-unused-expression
injectGlobal(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  .sinoui-form-item .sinoui-select-field {\n    margin-top: 4px;\n    width: 100%;\n  }\n\n  .sinoui-form-item .sinoui-select-field .sinoui-select__content {\n    flex: 1;\n  }\n"], ["\n  .sinoui-form-item .sinoui-select-field {\n    margin-top: 4px;\n    width: 100%;\n  }\n\n  .sinoui-form-item .sinoui-select-field .sinoui-select__content {\n    flex: 1;\n  }\n"])));
function isChildrenEqual(children, prevChildren) {
    return (children === prevChildren ||
        React.Children.count(children) === React.Children.count(prevChildren));
}
var SelectInner = /** @class */ (function (_super) {
    tslib_1.__extends(SelectInner, _super);
    function SelectInner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (event, value) {
            var _a = _this.props, inputProps = _a.inputProps, field = _a.field, form = _a.form;
            form.setFieldValue(field.name, value);
            if (inputProps.onChange) {
                inputProps.onChange(value, form);
            }
        };
        _this.onBlur = function (event) {
            var _a = _this.props, field = _a.field, form = _a.form;
            form.setFieldTouched(field.name, true);
            if (event && event.persist) {
                event.persist();
            }
            if (field.onBlur) {
                setTimeout(function () {
                    field.onBlur(event);
                }, 100);
            }
        };
        return _this;
    }
    SelectInner.prototype.shouldComponentUpdate = function (nextProps) {
        var inputProps = nextProps.inputProps, children = nextProps.children, field = nextProps.field, form = nextProps.form;
        var _a = this.props, prevInputProps = _a.inputProps, prevChildren = _a.children, prevField = _a.field, prevForm = _a.form;
        var error = form.touched[field.name] && form.errors[field.name];
        var prevError = prevForm.touched[field.name] && prevForm.errors[field.name];
        if (inputProps !== prevInputProps ||
            inputProps.name !== prevInputProps.name ||
            field.value !== prevField.value ||
            !isChildrenEqual(children, prevChildren) ||
            error !== prevError) {
            return true;
        }
        return false;
    };
    SelectInner.prototype.render = function () {
        var _a = this.props, inputProps = _a.inputProps, field = _a.field, form = _a.form, children = _a.children;
        var NativeSelectComponent = inputProps.nativeSelectComponent || NativeSelect;
        var options = (React.Children.map(children, 
        // tslint:disable-next-line:no-any
        function (child) {
            return child &&
                child.props && (React.createElement(MenuListItem, tslib_1.__assign({ key: child.props.value }, child.props)));
        }) || []).filter(Boolean);
        return (React.createElement(NativeSelectComponent, tslib_1.__assign({}, inputProps, field, { value: field.value || (inputProps.multiple ? [] : ''), wrapperClassName: "sinoui-select-field", error: !!(form.touched[field.name] && form.errors[field.name]), id: field.name, iconHidden: inputProps.readOnly || inputProps.disabled, onChange: this.onChange, onBlur: this.onBlur }), options));
    };
    return SelectInner;
}(React.Component));
export default withField()(SelectInner);
var templateObject_1;
//# sourceMappingURL=Select.js.map